import React, { useEffect, useState } from "react";
import api from "../../../../../api/axios";
import Swal from "sweetalert2";

const AddRoom = ({ roomTypes, fetchRooms }) => {
  const [selectedRoomType, setSelectedRoomType] = useState("");
  const [formData, setFormData] = useState({
    room_type_id: "",
    capacity: "",
    extra_capability: "",
    room_price: "",
    bed_charge: "",
    room_size: "",
    bed_number: "",
    room_Description: "",
    bed_type: "",
    reserve_condition: "",
    is_active: true,
    room_number: "",
  });

  const handleRoomTypeChange = (e) => {
    setSelectedRoomType(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log(formData);

    try {
      await api.post("/pms/rooms", formData);
      Swal.fire("Success", "Room added successfully", "success");
      fetchRooms();
    } catch (err) {
      Swal.fire("Error", "Failed to add room", "error");
      console.error(err);
    }
  };

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="add-room"
      aria-labelledby="add-room"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">Add Room</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Room Number <span className="text-danger">*</span>
            </label>
            <input
              name="room_number"
              className="form-control"
              value={formData.room_number}
              onChange={handleChange}
              placeholder="Room Number"
            />
          </div>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Room Type <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              value={formData.room_type_id}
              onChange={handleChange}
              name="room_type_id"
              required
            >
              <option value="">Select Room Type</option>
              {roomTypes?.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Capacity <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="capacity"
              className="form-control"
              value={formData.capacity}
              onChange={handleChange}
              placeholder="Capacity"
            />
          </div>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Extra Capability <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="extra_capability"
              className="form-control"
              value={formData.extra_capability}
              onChange={handleChange}
              placeholder="Capacity"
            />
          </div>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Room Price <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="room_price"
              className="form-control"
              value={formData.room_price}
              onChange={handleChange}
              placeholder="Room Price"
            />
          </div>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Bed Charge <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="bed_charge"
              className="form-control"
              value={formData.bed_charge}
              onChange={handleChange}
              placeholder="Bed Charge"
            />
          </div>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Room Size <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              name="room_size"
              value={formData.room_size}
              onChange={handleChange}
            >
              <option defaultValue="selected">Choose Room Size</option>
              <option value="single">Single</option>
              <option value="Double">Double</option>
              <option value="Triple">Triple</option>
              <option value="Quad">Quad</option>
              <option value="Queen">Queen</option>
              <option value="King">King</option>
              <option value="Others">Others</option>
            </select>
          </div>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Bed Number <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="bed_number"
              className="form-control"
              value={formData.bed_number}
              onChange={handleChange}
              placeholder="Bed Number"
            />
          </div>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Bed Type <span className="text-danger">*</span>
            </label>
            <select
              name="bed_type"
              className="form-select"
              value={formData.bed_type}
              onChange={handleChange}
            >
              <option defaultValue="selected">Choose Room Size</option>
              <option value="king_bed">King Bed</option>
              <option value="queenbed">Queen Bed</option>
              <option value="electricbed">Electric Bed</option>
              <option value="futonbed">Futon Bed</option>
              <option value="mattressbed">Mattress Bed</option>
              <option value="airbed">Air Bed</option>
            </select>
          </div>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Room Description <span className="text-danger">*</span>
            </label>
            <textarea
              name="room_Description"
              className="form-control"
              value={formData.room_Description}
              onChange={handleChange}
            ></textarea>
          </div>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Reserve Condition <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              name="reserve_condition"
              value={formData.reserve_condition}
              onChange={handleChange}
            ></textarea>
          </div>
          <div className="d-flex">
            <button type="button" className="btn w-100 me-1 py-2 btn-primary">
              Clear
            </button>
            <button type="submit" className="btn w-100 ms-1 py-2 btn-dark">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddRoom;
